import {
  AfterViewInit,
  Component,
  ViewChild,
  OnInit,
  Inject,
  ElementRef,
} from '@angular/core';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatSort, Sort } from '@angular/material/sort';
import { Router } from '@angular/router';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { MatChipInputEvent } from '@angular/material/chips';
import { ChangeDetectorRef } from '@angular/core';
// import { MsalUserService } from 'src/app/Service/msaluser.service';
import { UserManagementService } from 'src/app/Service/user-management.service';
import { MatDialog } from '@angular/material/dialog';
import { UserProfileComponent } from 'src/app/modals/user-profile/user-profile.component';
import { DatePipe } from '@angular/common';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  Validators,
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { strings } from '@material/form-field';
import { RemarkPopupComponent } from 'src/app/modals/remark-popup/remark-popup.component';

/**
 * @title Table with pagination
 */
/**
 * @title Table with sorting
 */
@Component({
  selector: 'app-add-blogs-list',
  templateUrl: './add-blogs-list.component.html',
  styleUrls: ['./add-blogs-list.component.scss'],
  providers: [DatePipe],
})
export class AddBlogsListComponent implements OnInit {
  @ViewChild(MatPaginator) paginator: MatPaginator;
  /*add for mat sort */

  @ViewChild(MatSort) sort: MatSort;
  // @ViewChild(MatSort, { static: true }) sort: MatSort;
  /* Mat chip input */
  selectable = true;
  removable = true;
  addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  fruits: any = [];
  myDate = new Date();
  /* Mat chip input */
  public matChipArray = [];

  namedata = '';
  typedata = '';
  categorydata = '';
  phonedata = '';
  districtdata = '';
  mandidata = '';
  languageData = '';
  displayedColumns: string[] = [
    'thumbnail',
    'datepublished',
    'title',
    'category',
    'languages',
    'lastmodifieddate',
    'likes',
    'action',
  ];
  userlist = [];
  userdata;
  selectedIndex = -1;
  dataSource;
  userId = '3fa85f64-5717-4562-b3fc-2c963f66afa6';
  hidepagination: boolean;
  accessToken;
  paginationProperty;
  hasNextPage;
  hasPreviousPage;
  nextPageNumber;
  pageNumber;
  pageSize;
  previousPageNumber;
  totalItems;
  totalPages;
  pageEvent: PageEvent;
  datasource: null;
  pageIndex: number;
  length: number;
  previousPageIndex;
  filterbyname = '';
  filterbytype = '';
  filterbycategory = '';
  filterbyphone = '';
  filterbymandi = '';
  filterbydistrict = '';
  pagechangeevent;
  dataSourcelist;
  datashow = true;
  datashowtrader = false;
  datashowfarmer = false;
  avtar = false;
  Viewprofile = false;
  category;
  categorydatalist = [];
  imageSrc: string | ArrayBuffer;
  uploadedImage: File;
  rolebased = [{ role: 'Crop Practices' }, { role: 'Articles' }];

  languageList = [
    { value: 'te', viewValue: 'Telugu' },
    { value: 'ta', viewValue: 'Tamil' },
    { value: 'kn', viewValue: 'Kannada' },
    { value: 'ml', viewValue: 'Malayalam' },
    { value: 'en', viewValue: 'English' },
    { value: 'hi', viewValue: 'Hindi' },
  ];
  Language: any;

  stateselect;
  datarole;
  totalcount;
  blogcount;
  countresult;
  blogcountmonth;
  modifiedTimestamp;
  maincategory;
  form: FormGroup;
  formdataedit = false;
  maincontent = true;
  listcategory;

  isChecked = false;
  languageMap: any = {
    te: 'Telugu',
    ta: 'Tamil',
    kn: 'Kannada',
    ml: 'Malayalam',
    en: 'English',
    hi: 'Hindi',
  };
  // new code
  EditUserAgentDetection = `
  <html>
<head>
<style>
#outer-div {
width: 100%;
text-align: center;
background-color: #0666a3
}
#inner-div {
display: inline-block;
margin: 0 auto;
padding: 3px;
background-color: #8ebf42
}
</style>


<link href="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css" rel="stylesheet" integrity="sha384-1BmE4kWBq78iYhFldvKuhfTAU6auU8tT94WrHftjDbrCEXSU1oBoqyl2QvZ6jIW3" crossorigin="anonymous">

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/js/bootstrap.bundle.min.js" integrity="sha384-ka7Sk0Gln4gmtz2MlQnikT1wXgYsOg+OMhuP+IlRH9sENBO0LRn5q+8nbTov4+1p" crossorigin="anonymous"></script>
</head>

<body>
<center>

</center>
<script>

var browserName = (function (agent) {
switch (true) {
case agent.indexOf("kalpavriksha-mobile-app") > -1: return "kalpavriksha-mobile-app"
 case agent.indexOf("edge") > -1: return "MS Edge";
 case agent.indexOf("edg/") > -1: return "Edge ( chromium based)";
 case agent.indexOf("opr") > -1 && !!window.opr: return "Opera";
 case agent.indexOf("chrome") > -1 && !!window.chrome: return "Chrome";
 case agent.indexOf("trident") > -1: return "MS IE";
 case agent.indexOf("firefox") > -1: return "Mozilla Firefox";
 case agent.indexOf("safari") > -1: return "Safari";
 default: return "other";
}
})
(window.navigator.userAgent.toLowerCase());

//For Hiding alert Inside Mobile PKF App and for rest browser it will display alert
if (browserName != "kalpavriksha-mobile-app") {

document.getElementById('input').innerHTML = "You are using " + browserName + " browser " ;
} 
else
{
document.getElementById('outer-div').style.display = "none";

}

</script>
</body>
</html> `;
  // new code end

  constructor(
    public _userService: UserManagementService,
    private datepipe: DatePipe,
    private spinner: NgxSpinnerService,
    private router: Router,
    private ref: ChangeDetectorRef,
    public dialog: MatDialog,
    private fb: FormBuilder,
    public toastr: ToastrService
  ) {}
  ngOnInit(): void {
    this.getallimage();
    this.editdata();
    this.getblogcategoryforFilter();
    setTimeout(() => {
      this.datarole = localStorage.getItem('UserRole');
      this.getAlluser();
    }, 1000);
    (this.hidepagination = true),
      // var tolen = this.msalService.GetAccessToken()
      this.spinner.show();

    setTimeout(() => {
      this.spinner.hide();
    }, 4000);

    this.accessToken = localStorage.getItem('msal.idtoken');

    // this._userService.getStates().subscribe(data => {
    //   this.stateselect = data
    //   this.states = this.stateselect.result.data;
    //   // this.spinner.hide();
    // });
    this.getCount();
    // (document as any).querySelectorAll("#check_all>label")[0].style.margin = '-22px 0px 0px -95px';
    // (document as any).querySelectorAll("#check_all>label")[0].style.position = 'absolute';
  }

  /*.......................................................GET ALL USER......................................................... */
  getAlluser() {
    this.spinner.show();
    var postdata = {
      search: '',
      fromDate: '',
      todate: '',
      category: '',
      type: '',
      language: '',
      pageNumber: 0,
    };
    this._userService.getblogdata(postdata).subscribe((data) => {
      this.userdata = data;
      this.userlist = this.userdata.result.data.list;

      this.paginationProperty = this.userdata.result.data;
      this.length = this.paginationProperty.totalItems;
      this.totalcount = this.paginationProperty.totalItems;
      this.previousPageIndex = this.paginationProperty.previousPageIndex;
      this.hasNextPage = this.paginationProperty.hasNextPage;
      this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
      this.pageIndex = this.paginationProperty.pageNumber;
      this.dataSource = new MatTableDataSource(this.userlist);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinner.hide();
    });
  }

  /* Total count */
  getCount() {
    this._userService.getblogcount().subscribe((count) => {
      this.countresult = count;
      this.blogcount = this.countresult.result.data.totalBlogs;
      this.blogcountmonth = this.countresult.result.data.postedBlogInaMonth;
    });
  }
  /* Total count */

  /*............................................GET ALL USER BY FILTER.............................................. */

  filterbytext = '';
  searchdata = '';
  filtersearch = false;

  changeFn(event: any) {
    // if(this.filtersearch = false) {
    if (event.isTrusted == true) {
      // if(this.filtersearch = false) {
      // this.searchfilter();
      this.applyfilter(false);
    }
    //  }
  }

  /*.........................................PAGINATION CONFIG................................................. */

  public getServerData(event?: PageEvent) {
    // this.spinner.show();/* Commented by shivam modi */
    this.pagechangeevent = event;
    this.pageIndex = this.pagechangeevent.pageIndex;
    this.length = this.pagechangeevent.length;
    this.pageSize = this.pagechangeevent.pageSize;

    if (this.exportcsvdata == true) {
      // this.applyfilter();

      var postdata = {
        search: this.filterbytext,
        fromDate: '',
        todate: '',
        category: this.filterbycategory,
        type: this.filterbytype,
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        language: this.filterbylanguageName,
      };

      this._userService.getblogdata(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    } else {
      postdata = {
        search: '',
        fromDate: '',
        todate: '',
        category: '',
        type: '',
        pageNumber: this.pageIndex,
        pageSize: this.pageSize,
        language: '',
      };

      this._userService.getblogdata(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }
  clearFilter() {
    this.spinner.show();
    window.location.reload();
  }

  getLanguages(ls: string) {
    let languages = [];
    if (ls.length === 0) return '';
    let larray = ls.split(',');
    larray.forEach((key) => {
      languages.push(this.languageMap[key.trim()]);
    });
    return languages.join(', ');
  }

  formPage() {
    this.router.navigate(['/add-blog']);
    setTimeout(() => {
      window.location.reload();
    }, 10);
  }
  /*Add by shivam modi */
  /*Export csv file */
  apidata;
  maindata;
  filename;
  exportcsvdata = false;

  exportcsv() {
    if (this.exportcsvdata == true) {
      this.applyfilter(false);
      var postdata = {
        userId: '',
        userRole: this.filterbytype,
        name: this.filterbyname,
        state: this.filterbycategory,
        district: this.filterbydistrict,
        search: this.filterbytext,
        marketPlace: this.filterbymandi,
        mobileNo: this.filterbyphone,
        documentStatus: '',
      };
      this._userService.getAllUserpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Users.xlsx';
        anchor.href = url;
        anchor.click();
        // window.open(url);
      });
    } else {
      var postdata = {
        userId: '',
        userRole: '',
        name: '',
        state: '',
        district: '',
        search: '',
        marketPlace: '',
        mobileNo: '',
        documentStatus: '',
      };
      this._userService.getAllUserpdf(postdata).subscribe((data) => {
        this.apidata = data;
        const blob = new Blob([this.apidata], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const url = window.URL.createObjectURL(blob);
        // window.open(url);
        var anchor = document.createElement('a');
        anchor.download = 'PKF_Users.xlsx';
        anchor.href = url;
        anchor.click();
      });
    }
  }
  filterbyname1;
  filterbylanguageName;
  languageName;
  applyfilter(checkEmpty) {
    if (
      checkEmpty &&
      !this.searchdata &&
      !this.languageName &&
      !this.category
    ) {
      this.toastr.warning('Please provide input first');
    } else {
      this.exportcsvdata = true;
      this.filterbytext = this.searchdata;
      this.filterbytype = this.typedata;
      this.filterbycategory = this.category;
      this.filterbylanguageName = this.languageName;
      // if(this.filterbyname == " " && this.filterbyrole == " " && this.filterbystate == " " && this.filterbyphone == " ")
      // {
      //      this.getAlluser();
      // }else{

      let indextype = this.matChipArray.findIndex((x) => x.tag === 'type');
      let indexcategory = this.matChipArray.findIndex(
        (x) => x.tag === 'category'
      );
      let indexlanguageName = this.matChipArray.findIndex(
        (x) => x.tag === 'languageName'
      );
      if (this.typedata != '') {
        if (indextype > -1) {
          this.matChipArray[indextype].name = 'Type' + ':' + this.typedata;
        } else {
          if (this.typedata != '' && this.typedata != undefined) {
            this.matChipArray.push({
              name: 'Type' + ':' + this.typedata,
              tag: 'type',
              flag: true,
            });
          }
        }
      }

      if (this.category != '') {
        if (indexcategory > -1) {
          this.matChipArray[indexcategory].name =
            'Category' + ':' + this.category;
        } else {
          if (this.category != '' && this.category != undefined) {
            this.matChipArray.push({
              name: 'Category' + ':' + this.category,
              tag: 'category',
              flag: true,
            });
          }
        }
      }

      if (this.languageMap[this.languageName] != '') {
        if (indexlanguageName > -1) {
          this.matChipArray[indexlanguageName].name =
            'Language' + ':' + this.languageMap[this.languageName];
        } else {
          if (
            this.languageMap[this.languageName] != '' &&
            this.languageMap[this.languageName] != undefined
          ) {
            this.matChipArray.push({
              name: 'Language' + ':' + this.languageMap[this.languageName],
              tag: 'languageName',
              flag: true,
            });
          }
        }
      }

      // if(this.filterbyrole !=  undefined || this.filterbyname !=  undefined ||this.filterbystate  !=  undefined )
      var postdata = {
        search: this.filterbytext,
        fromDate: '',
        todate: '',
        category: this.filterbycategory,
        type: this.filterbytype,
        pageNumber: 0,
        pageSize: 10,
        language: this.filterbylanguageName,
      };

      this._userService.getblogdata(postdata).subscribe((data) => {
        this.userdata = data;
        this.userlist = this.userdata.result.data.list;
        this.paginationProperty = this.userdata.result.data;
        this.length = this.paginationProperty.totalItems;
        this.previousPageIndex = this.paginationProperty.previousPageIndex;
        this.hasNextPage = this.paginationProperty.hasNextPage;
        this.hasPreviousPage = this.paginationProperty.hasPreviousPage;
        this.pageIndex = this.paginationProperty.pageNumber;
        this.dataSource = new MatTableDataSource(this.userlist);
        this.dataSource.sort = this.sort;
        this.spinner.hide();
      });
    }
  }

  remove(index, tag): void {
    if (tag === 'type') {
      this.matChipArray.splice(index, 1);
      this.typedata = '';
    }
    if (tag === 'category') {
      this.matChipArray.splice(index, 1);
      this.category = '';
    }

    if (tag === 'languageName') {
      this.matChipArray.splice(index, 1);
      this.languageName = '';
    }

    this.applyfilter(false);
  }
  listPage() {
    this.formdataedit = false;
    this.maincontent = true;
    // this.getAlluser();
    this.applyfilter(false);
  }

  /*model pop up for delete same page  */
  openDialog(data): void {
    const dialogRef = this.dialog.open(DeletBlogPopup, {
      // width: '30%',
      // height: '30%',
      data: { id: data },
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.applyfilter(false);
      this.getCount();
    });
  }
  /*model pop up same page  */
  /*Export data field selection pop-up*/
  dialogresult;
  mainresult;
  openDialogexport(): void {
    const dialogRef = this.dialog.open(ExportData, {
      width: '60%',
      height: 'auto',
      //  data: {id: data}
    });
    dialogRef.afterClosed().subscribe((result) => {
      this.dialogresult = result;
      //================================REPORT GENERATE==========================================//
      if (this.dialogresult != undefined) {
        this.mainresult = JSON.parse(this.dialogresult.data);
        if (this.mainresult.length != 0) {
          let Result = this.mainresult.map((choice) => choice.value);
          let text = confirm('Are you sure you want to export this file?');
          if (text == true) {
            if (this.exportcsvdata == true) {
              this.applyfilter(false);
              var postdata = {
                search: this.filterbytext,
                fromDate: '',
                todate: '',
                category: this.categorydata,
                type: this.filterbytype,
                reportList: Result,
                language: this.filterbylanguageName,
              };
              this._userService.getallblogpdf(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_Blog.xlsx';
                anchor.href = url;
                anchor.click();
              });
            } else {
              postdata = {
                search: '',
                fromDate: '',
                todate: '',
                category: '',
                type: '',
                reportList: Result,
                language: '',
              };
              this._userService.getallblogpdf(postdata).subscribe((data) => {
                this.apidata = data;
                const blob = new Blob([this.apidata], {
                  type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                });
                const url = window.URL.createObjectURL(blob);
                // window.open(url);
                var anchor = document.createElement('a');
                anchor.download = 'PKF_Blog.xlsx';
                anchor.href = url;
                anchor.click();
              });
            }
          } else {
            this.openDialogexport();
          }
        } else {
          alert('Please select atleast any one column to generate report!');
          this.openDialogexport();
        }
      }
    });
  }
  //================================REPORT GENERATE==========================================//
  /*Export data field selection pop-up*/
  //* Edit functionality  *//
  getblogcategoryforFilter() {
    this._userService.getblogcategory().subscribe((category) => {
      this.listcategory = category;
      this.maincategory = this.listcategory.result.data;
    });
  }
  editdata() {
    this.form = this.fb.group({
      categorydata: [],
      languages: [],
      titledata: ['', [Validators.required]],
      ckeditordata: ['', [Validators.required]],
      id: [],
      image: new FormControl(''),
    });
  }
  roledata = {};
  Category;
  title;
  categorylist = false;
  maincategorydata;
  name;
  iddata;
  image;
  Categorylistdata;
  ckeConfig: any;

  blogFileSelected(event) {
    this.uploadedImage = event.target.files[0];
    this.form.get('image')?.setValue(this.uploadedImage);
    if (event.target.files && event.target.files[0]) {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => (this.imageSrc = reader.result);
      console.log('image', this.imageSrc);
      reader.readAsDataURL(file);
    }
  }

  edit(id) {
    /* */
    this.ckeConfig = {
      //easyimage
      allowedContent: true,
      extraPlugins:
        'uploadimage,dialogui,dialog,a11yhelp,about,basicstyles,bidi,blockquote,clipboard,' +
        'button,panelbutton,panel,floatpanel,colorbutton,colordialog,menu,' +
        'contextmenu,dialogadvtab,div,elementspath,enterkey,entities,popup,' +
        'filebrowser,find,fakeobjects,floatingspace,listblock,richcombo,' +
        'font,format,forms,horizontalrule,htmlwriter,iframe,image,indent,' +
        'indentblock,indentlist,justify,link,list,liststyle,magicline,' +
        'maximize,newpage,pagebreak,pastefromword,pastetext,preview,print,' +
        'removeformat,resize,save,menubutton,scayt,selectall,showblocks,' +
        'showborders,smiley,sourcearea,specialchar,stylescombo,tab,table,' +
        'tabletools,templates,toolbar,undo,wsc,wysiwygarea,',
      removePlugins: 'flash',
    };
    this.ckeConfig = {
      extraPlugins: 'embed,autoembed,image2',
      height: 500,

      // Load the default contents.css file plus customizations for this sample.
      contentsCss: [
        // 'http://cdn.ckeditor.com/4.17.1/full-all/contents.css',
        'https://ckeditor.com/docs/ckeditor4/4.17.1/examples/assets/css/widgetstyles.css',
      ],
      // Setup content provider. See https://ckeditor.com/docs/ckeditor4/latest/features/media_embed
      embed_provider:
        '//ckeditor.iframe.ly/api/oembed?url={url}&callback={callback}',
      // Configure the Enhanced Image plugin to use classes instead of styles and to disable the
      // resizer (because image size is controlled by widget styles or the image takes maximum
      // 100% of the editor width).
      image2_alignClasses: [
        'image-align-left',
        'image-align-center',
        'image-align-right',
      ],
      image2_disableResizer: false,
      removeButtons:
        'PasteFromWord,Flash,Anchor,Unlink,HiddenField,Button,Select,Form,Checkbox,Textarea,TextField,Radio,IFrame,Source,Save,NewPage,Templates,BidiLtr,BidiRtl,Language,PageBreak,Iframe,About',
    };

    /*ckeditor menu */
    this.categorylist = false;
    this._userService.getblogdetails(id).subscribe((data) => {
      var result = data;
      // debugger
      // if (data["result"].data.type == "Crop Practices") {
      //   this.categorylist = true;
      // }
      this.form.get('categorydata').setValue(data['result'].data.categoryID);
      this.formdataedit = true;
      this.maincontent = false;
      this.roledata = data['result'].data.type;
      this.Categorylistdata = data['result'].data.categoryID.toUpperCase();
      this.title = data['result'].data.title;
      this.name = data['result'].data.blogdescription;
      this.iddata = data['result'].data.id;
      this.languageData = data['result'].data.language;
      this.category = data['result'].data.categoryName;
      this.image = data['result'].data.imageUrl;
    });
  }
  catid;
  response;

  dataURItoBlob(dataURI) {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0)
      byteString = atob(dataURI.split(',')[1]);
    else byteString = unescape(dataURI.split(',')[1]);

    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    return new Blob([ia], { type: mimeString });
  }

  onSubmit() {
    //debugger
    let x;
    const ref = this.openRemarkDialog();
    ref.afterClosed().subscribe((data) => {
      x = data;
      if (this.form.valid && x) {
        const formData: FormData = new FormData();
        formData.append('blogID', this.form.value.id);
        // formData.append("type", this.form.value.type)
        formData.append('categoryID', this.form.value.categorydata);
        formData.append(
          'details',
          this.EditUserAgentDetection + this.form.value.ckeditordata
        );
        formData.append('language', this.form.value.languages);
        formData.append('title', this.form.value.titledata);
        formData.append('image', this.form.value.image);
        formData.append('remark', x);

        this._userService.updateblogdata(formData).subscribe((result) => {
          this.response = result;
          this.spinner.show();
          if (this.response.result.message == 'Blog already exist.') {
            this.response = result;
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
            this.spinner.hide();
          } else {
            this.response = result;
            this.toastr.success(this.response.result.message, 'Success', {
              timeOut: 3000,
            });
            this.listPage();
            this.spinner.hide();
          }
        });
      } else {
        this.toastr.error('Please Fill the details');
      }
    });
  }

  openRemarkDialog() {
    const dialogRef = this.dialog.open(RemarkPopupComponent, {});
    return dialogRef;
  }

  doSomething(data) {
    if (data.value == 'Crop Practices') {
      this.categorylist = true;
    } else if (data.value == 'Articles') {
      this.categorylist = false;
    }
  }
  // resultdata;imageurllisting;
  // getallimage(){
  //   this._userService.getuploadimage().subscribe(data=>{
  //     this.resultdata = data;
  //     this.imageurllisting = this.resultdata.result.data
  //     // this.ngOnInit();
  //   })
  // }

  fileData;
  finaldata;
  savescheme = false;
  lastFilePath: any;
  file1: any;
  processImage(event) {
    this.isButtonVisible = true;
    let splitfile = event.target.files;

    this.lastFilePath = this.myInputVariable.nativeElement.value;
    let files: [] = event.target.files;
    this.file1 = [];

    for (let i = 0; i < splitfile.length; i++) {
      let type = splitfile[i].type.split('/');
      if (
        !(
          type[1] == 'jpeg' ||
          type[1] == 'jpg' ||
          type[1] == 'png' ||
          type[1] == 'pdf'
        )
      ) {
        this.finaldata = 0;
        this.myInputVariable.nativeElement.value = '';
        this.savescheme = false;
        this.isButtonVisible = false;
        this.toastr.warning(
          'Accepted File Formats PDF,PNG.JPG and JPEG only',
          'Info',
          {
            timeOut: 3000,
          }
        );
        return;
      } else if (splitfile[i].size >= 5242900) {
        this.myInputVariable.nativeElement.value = '';
        this.toastr.warning('Accepted File Size should be below 5MB', 'Info', {
          timeOut: 3000,
        });
        return;
      } else {
        this.file1.push(splitfile[i]);
      }
    }
    this.finaldata = this.file1;
    this.savescheme = true;
    this.submit_file();
  }

  resetButton() {
    this.form.reset();
  }

  submit_file() {
    if (this.finaldata != undefined && this.finaldata != '') {
      let selectedFiles = [];
      for (let i = 0; i < this.finaldata.length; i++) {
        selectedFiles.push(this.finaldata[i]);
      }

      const postdata = new FormData();
      selectedFiles.forEach((f) => postdata.append('postblogimages', f));
      //const postdata = new FormData();
      //postdata.append('postblogimages', this.finaldata);
      this._userService.imageuploadblog(postdata).subscribe((data) => {
        this.response = data;
        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        // window.location.reload();
      });
      setTimeout(() => {
        this.getallimage();
      }, 3000);
    }
    this.removeFile();
  }
  isButtonVisible = false;
  @ViewChild('inputFile') myInputVariable: ElementRef;
  removeFile() {
    this.isButtonVisible = false;
    this.myInputVariable.nativeElement.value = '';
  }

  resultdata;
  imageurllisting;
  newImageurllisting;
  getallimage() {
    let isSelected = false;
    // let newImageurllisting = []
    this._userService.getuploadimage().subscribe((data) => {
      this.resultdata = data;
      this.imageurllisting = this.resultdata.result.data;
      // this.ngOnInit();
      this.newImageurllisting = this.imageurllisting.map(function (el) {
        var o = Object.assign({}, el);
        o.isSelected = false;
        return o;
      });
      this.ref.detectChanges();
    });
  }

  deleteImage() {
    this.isChecked = false;
    let totalDeleteItem = [];

    this.newImageurllisting.forEach((item) => {
      if (item.isSelected == true) {
        totalDeleteItem.push(item.blogImageID);
      }
    });

    if (totalDeleteItem.length == 0) {
      this.toastr.warning('Please select images for delete.');
    } else if (totalDeleteItem.length == 1) {
      let text = confirm('Are you sure you want to delete this image?');
      if (text == true) {
        var postdata = totalDeleteItem;
        this._userService.deleteBlogImages(postdata).subscribe((result) => {
          this.response = result;
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
          this.getallimage();
        });
      } else {
        this.newImageurllisting.forEach((item) => {
          item.isSelected = false;
        });
      }
    } else {
      let text = confirm('Are you sure you want to delete these images?');
      if (text == true) {
        var postdata = totalDeleteItem;
        this._userService.deleteBlogImages(postdata).subscribe((result) => {
          this.response = result;
          this.toastr.success(this.response.result.message, 'Success', {
            timeOut: 3000,
          });
          this.getallimage();
        });
      } else {
        this.newImageurllisting.forEach((item) => {
          item.isSelected = false;
        });
      }
    }
  }
  //* Edit functionality  *//
}
/* ===========================================delet-pop-up==============================================================*/
@Component({
  selector: 'delet-blog-popup',
  templateUrl: 'delet-blog-popup.html',
})
export class DeletBlogPopup {
  formdelet: FormGroup;
  response;
  constructor(
    public dialogRef: MatDialogRef<DeletBlogPopup>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cd: ChangeDetectorRef,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {}
  onNoClick(): void {
    this.dialogRef.close();
  }
  ngOnInit(): void {
    this.formdelet = this.fb.group({
      Remark: ['', [Validators.required]],
    });
  }
  onSubmit() {
    if (this.formdelet.valid) {
      var postdata = {
        blogID: this.data.id,
        remark: this.formdelet.value.Remark,
      };
      this._userService.removeblogdata(postdata).subscribe((data) => {
        this.response = data;
        // window.location.reload();

        this.toastr.success(this.response.result.message, 'Success', {
          timeOut: 3000,
        });
        this.dialogRef.close();
      });
      // this.router.navigateByUrl('', { skipLocationChange: true }).then(() => {
      //   this.router.navigate(['/Govt-schemes-list']);
      //   // this.spinner.hide()
      // });
    } else {
      alert('Please enter valid remark !');
      return false;
    }
  }
}
/* ===========================================delet-pop-up==============================================================*/
/* ===========================================Export-function ==============================================================*/
@Component({
  selector: 'export-data-popup',
  templateUrl: 'export-data.html',
})
export class ExportData {
  response;
  title = 'Select/ Unselect All Checkboxes';
  masterSelected: boolean;
  checklist: any;
  checkedList: any;
  constructor(
    public dialogRef: MatDialogRef<ExportData>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public _userService: UserManagementService,
    public toastr: ToastrService,
    private router: Router
  ) {
    this.masterSelected = false;
    this.checklist = [
      { id: 1, viewValue: 'Title', value: 'Title', isSelected: false },
      { id: 2, viewValue: 'Category', value: 'Category', isSelected: false },
      // { id: 3, viewValue: 'Type', value: 'Type', isSelected: false },
      {
        id: 4,
        viewValue: 'Date Published',
        value: 'Datepublished',
        isSelected: false,
      },
      {
        id: 5,
        viewValue: 'Last Modified',
        value: 'lastModified',
        isSelected: false,
      },
      { id: 6, viewValue: 'Likes', value: 'Likes', isSelected: false },
      { id: 7, viewValue: 'Language', value: 'Language', isSelected: false },
    ];
    this.getCheckedItemList();
  }
  //  onNoClick(): void {
  //   // this.dialogRef.close();
  //  }
  ngOnInit(): void {
    // this.getCheckedItemList();
  }

  // The master checkbox will check/ uncheck all items
  checkUncheckAll() {
    for (var i = 0; i < this.checklist.length; i++) {
      this.checklist[i].isSelected = this.masterSelected;
    }
    this.getCheckedItemList();
  }

  // Check All Checkbox Checked
  isAllSelected() {
    this.masterSelected = this.checklist.every(function (item: any) {
      return item.isSelected == true;
    });
    this.getCheckedItemList();
  }
  // Get List of Checked Items
  getCheckedItemList() {
    this.checkedList = [];
    for (var i = 0; i < this.checklist.length; i++) {
      if (this.checklist[i].isSelected)
        this.checkedList.push(this.checklist[i]);
    }
    this.checkedList = JSON.stringify(this.checkedList);
  }
  closeDialog() {
    this.dialogRef.close({ data: this.checkedList });
  }
  closeDialogtest() {
    this.dialogRef.close();
  }
}
/* ===========================================Export-function ==============================================================*/
